import { combineReducers } from "redux";
import {
  fetching,
  submitting,
  items,
  togglable,
  selectable,
} from "./resource";

export default combineReducers({
  selectedItem: selectable("productTypes"),
  isFetching: fetching("productTypes"),
  isSubmitting: submitting("productTypes"),
  items: items("productTypes"),
  showAddModal: togglable("addModal"),
});
